import React, {createContext, useContext, useMemo, useState} from 'react'
import {ThemeProvider} from '@mui/material/styles'
import type {Theme} from '@mui/material/styles'
import {CssBaseline} from '@mui/material'
import type {PaletteMode} from '@mui/material'
import {makeFeltTheme} from './feltTheme'

type ThemeFactory = (mode: PaletteMode) => Theme
const ThemeModeContext = createContext({mode: 'dark' as PaletteMode, setMode: (_mode: PaletteMode) => {}})
export const useThemeMode = () => useContext(ThemeModeContext)
export function AppThemeProvider({children, themeFactory = makeFeltTheme}: {children: React.ReactNode; themeFactory?: ThemeFactory}) {
  const [mode, setMode] = useState<PaletteMode>('dark')
  const theme = useMemo(() => themeFactory(mode), [themeFactory, mode])
  return <ThemeModeContext.Provider value={{mode, setMode}}>
    <ThemeProvider theme={theme}><CssBaseline/>{children}</ThemeProvider>
  </ThemeModeContext.Provider>
}
